import { Icon } from '@iconify/react';
import tableStyles from './AdministratorDashboard/Tables/Table.module.scss';
import Tooltip from './components/Tooltip';
import styles from './ConcerningEmotionsReport.module.scss';

interface Props {
  scopeNote?: string;
}

const ConcerningEmotionsReportHeader = ({ scopeNote }: Props): JSX.Element => (
  <>
    <h1 className={styles.title}>
      Concerning Emotions Report
      <Tooltip
        content='Students are flagged based on their check-in patterns'
        direction='top'
        color='white'
        maxWidth='160px'
      >
        <p className={tableStyles.tooltipIcon}>?</p>
      </Tooltip>
    </h1>
    <p className={styles.disclaimer}>
      <Icon className={styles.disclaimerIcon} icon='mdi:information-outline' />
      <span>
        This report helps you notice students who may benefit from a caring check-in.{' '}
        <strong className={styles.disclaimerEmphasis}>
          It is not a clinical tool and is not designed to detect or assess crisis.
        </strong>
      </span>
    </p>
    {scopeNote && <p className={styles.scopeNote}>{scopeNote}</p>}
  </>
);

export default ConcerningEmotionsReportHeader;
